import SoftBadge from "modules/common/SoftBadge";
import React, { useEffect, useState } from "react";

function VayuTableHeader({ dates, setActiveTab, doc }) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    setActiveTab(dates[0]);
  }, [doc]);

  return (
    <div
      style={{ width: "100%", overflowX: "auto" }}
      className="p-2 d-flex align-items-center flex-nowrap scrollable-container"
    >
      {dates?.map((date, index) => {
        return active === index && !isNaN(active) ? (
          <SoftBadge className="p-3" key={index} style={{ minWidth: "14rem" }}>
            {date}
          </SoftBadge>
        ) : (
          <p
            key={index}
            style={{ minWidth: "13rem" }}
            className="m-0 p-2 rounded cursor-pointer"
            onClick={() => {
              setActive(index);
              setActiveTab(date);
            }}
          >
            {date}
          </p>
        );
      })}
    </div>
  );
}

export default VayuTableHeader;
